import { MutationTree } from 'vuex';
import IAboutState from './types/IAboutState';
import IAboutMeta from './types/IAboutMeta';
import IAboutHeader from './types/IAboutHeader';
import { IAboutSection } from './types/IAboutSection';

const mutations: MutationTree<IAboutState> = {
  setMeta(state: IAboutState, meta: IAboutMeta) {
    state.meta = meta;
  },

  setHeader(state: IAboutState, header: IAboutHeader) {
    state.header = header;
  },

  setSections(state: IAboutState, sections: IAboutSection[]) {
    state.sections = sections;
  },
};

export default mutations;
